import { identity } from 'lodash';
import { getLayoutName } from '../layout-types';
// Post design params
export const IS_MOBILE_DESIGN_SETTINGS_ENABLED = 'blog-mobile-isMobileDesignSettingsEnabled';
export const IS_MOBILE_DESIGN_SETTINGS_ENABLED_PATH = `style.booleans.${IS_MOBILE_DESIGN_SETTINGS_ENABLED}`;
export const TITLE_FONT_SIZE = 'titleFontSize';
export const DESCRIPTION_FONT_SIZE = 'descriptionFontSize';
export const IS_FEED_DESIGN_PROPS_MIGRATED = 'blog-isFeedDesignPropsMigrated';
export const IS_FEED_DESIGN_PROPS_MIGRATED_PATH = `style.booleans.${IS_FEED_DESIGN_PROPS_MIGRATED}`;
export const IS_CONFIGURABLE_LINE_CLAMPING_ENABLED = 'blog-isConfigurableLineClampingEnabled';
export const IS_CONFIGURABLE_LINE_CLAMPING_ENABLED_PATH = `style.booleans.${IS_CONFIGURABLE_LINE_CLAMPING_ENABLED}`;
export const POST_TITLE_COLOR = 'post-titleColor';
export const POST_TEXT_COLOR = 'post-textColor';
export const POST_TEXT_COLOR_PATH = `style.colors.${POST_TEXT_COLOR}`;
export const POST_TITLE_FONT = 'post-titleFont';
export const POST_TITLE_FONT_PATH = `style.fonts.${POST_TITLE_FONT}`;
export const POST_DESCRIPTION_FONT = 'post-descriptionFont';
export const POST_PAGE_FONT = 'post-pageFont';
export const POST_PAGE_FONT_PATH = `style.fonts.${POST_PAGE_FONT}`;
export const POST_TITLE_FONT_SIZE_MOBILE = `post-mobile-${TITLE_FONT_SIZE}`;
export const POST_TITLE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_TITLE_FONT_SIZE_MOBILE}`;
export const POST_PAGE_FONT_SIZE_MOBILE = 'post-mobile-pageFontSize';
export const POST_PAGE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_PAGE_FONT_SIZE_MOBILE}`;
export const getPostLayoutParamByName = (...params) => `post-${params.filter(identity).join('-')}`;
export const getPostLayoutParamByType = (layoutType, section, param, isMobile = false) => getPostLayoutParamByName(getLayoutName(layoutType), section, isMobile ? 'mobile' : '', param);
export const getPostTitleFontSize = (layout, section, isMobile) => getPostLayoutParamByType(layout, section, TITLE_FONT_SIZE, isMobile);
export const getPostDescriptionFontSize = (layout, section, isMobile) => getPostLayoutParamByType(layout, section, DESCRIPTION_FONT_SIZE, isMobile);
export const getPostMetadataFontSize = (layout, section) => getPostLayoutParamByType(layout, section, 'metadataFontSize');
export const getPostFontSizesPath = (...args) => `style.numbers.${getPostLayoutParamByType(...args)}`;
export const getGenericPostFontPath = (section, font) => `style.fonts.${getPostLayoutParamByName(section, font)}`;
export const getCardBorderWidth = (layout, section) => `post-${getLayoutName(layout)}-${section}-cardBorderWidth`;
export const getCardBorderWidthPath = (...args) => `style.numbers.${getCardBorderWidth(...args)}`;
export const getFeedBorderColor = (section) => `post-${section}-borderColor`;
export const getFeedBorderColorPath = (section) => `style.colors.${getFeedBorderColor(section)}`;
export const getMobileFeedBorderColor = (section) => `post-${section}-mobile-borderColor`;
export const getMobileFeedBorderColorPath = (section) => `style.colors.${getMobileFeedBorderColor(section)}`;
export const CARD_BACKGROUND_COLOR = 'post-cardBackgroundColor';
export const CARD_BACKGROUND_COLOR_PATH = `style.colors.${CARD_BACKGROUND_COLOR}`;
export const CARD_BORDER_COLOR = 'post-cardBorderColor';
export const CARD_BORDER_WIDTH = 'post-cardBorderWidth';
export const CARD_BORDER_WIDTH_PATH = `style.numbers.${CARD_BORDER_WIDTH}`;
export const APP_BACKGROUND_COLOR = 'post-appBackgroundColor';
export const APP_BACKGROUND_COLOR_PATH = `style.colors.${APP_BACKGROUND_COLOR}`;
export const APP_BACKGROUND_CATEGORY_COLOR = 'post-appBackgroundCategoryColor';
export const APP_BACKGROUND_CATEGORY_COLOR_PATH = `style.colors.${APP_BACKGROUND_CATEGORY_COLOR}`;
// Post advanced design options
export const POST_HEADER_TWO_FONT = 'post-headerTwoFont';
export const POST_HEADER_TWO_COLOR = 'post-headerTwoColor';
export const POST_HEADER_THREE_FONT = 'post-headerThreeFont';
export const POST_HEADER_THREE_COLOR = 'post-headerThreeColor';
export const POST_HEADER_FOUR_FONT = 'post-headerFourFont';
export const POST_HEADER_FOUR_COLOR = 'post-headerFourColor';
export const POST_HEADER_FIVE_FONT = 'post-headerFiveFont';
export const POST_HEADER_FIVE_COLOR = 'post-headerFiveColor';
export const POST_HEADER_SIX_FONT = 'post-headerSixFont';
export const POST_HEADER_SIX_COLOR = 'post-headerSixColor';
export const POST_QUOTES_FONT = 'post-quotesFont';
export const POST_QUOTES_COLOR = 'post-quotesColor';
export const POST_HEADER_TWO_FONT_SIZE_MOBILE = 'post-mobile-headerTwoFontSize';
export const POST_HEADER_TWO_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_TWO_FONT_SIZE_MOBILE}`;
export const POST_HEADER_THREE_FONT_SIZE_MOBILE = 'post-mobile-headerThreeFontSize';
export const POST_HEADER_THREE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_THREE_FONT_SIZE_MOBILE}`;
export const POST_HEADER_FOUR_FONT_SIZE_MOBILE = 'post-mobile-headerFourFontSize';
export const POST_HEADER_FOUR_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_FOUR_FONT_SIZE_MOBILE}`;
export const POST_HEADER_FIVE_FONT_SIZE_MOBILE = 'post-mobile-headerFiveFontSize';
export const POST_HEADER_FIVE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_FIVE_FONT_SIZE_MOBILE}`;
export const POST_HEADER_SIX_FONT_SIZE_MOBILE = 'post-mobile-headerSixFontSize';
export const POST_HEADER_SIX_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_SIX_FONT_SIZE_MOBILE}`;
export const POST_QUOTES_FONT_SIZE_MOBILE = 'post-mobile-quotesFontSize';
export const POST_QUOTES_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_QUOTES_FONT_SIZE_MOBILE}`;
export const IS_POST_ADVANCED_DESIGN_OPTIONS_ENABLED = 'post-isAdvancedDesignOptionsEnabled';
export const IS_POST_ADVANCED_DESIGN_OPTIONS_ENABLED_PATH = `style.booleans.${IS_POST_ADVANCED_DESIGN_OPTIONS_ENABLED}`;
export const POST_RATING_FILLED_STAR_COLOR = 'post-ratingFilledStarColor';
export const POST_RATING_UNFILLED_STAR_COLOR = 'post-ratingUnfilledStarColor';
export const POST_RATING_FONT = 'post-ratingFont';
export const POST_RATING_FONT_COLOR = 'post-ratingFontColor';
// Button design params
export const BUTTON_COLOR = 'button-color';
export const BUTTON_COLOR_PATH = `style.colors.${BUTTON_COLOR}`;
export const BUTTON_TEXT_COLOR = 'button-textColor';
export const SECONDARY_ICON_COLOR = 'icon-secondaryColor';
export const SECONDARY_ICON_COLOR_PATH = `style.colors.${SECONDARY_ICON_COLOR}`;
// Link and hashtag params
export const LINK_AND_HASHTAG_COLOR = 'blog-linkHashtagColor';
export const POST_HOMEPAGE_LINK_AND_HASHTAG_COLOR = 'post-homepage-linkHashtagColor';
//# sourceMappingURL=post.wix-params.js.map